export default "__VITE_ASSET__DkPKBbnB__"